module.exports = __webpack_public_path__ + "img/Z61_18.b473ab1b.jpg";